module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    staticClass: "OrganizationViewing"
  }, [_c('div', {
    staticClass: "form-group col-md-5"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.org.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.org.description))]), _vm._v(" "), _c('p', [_vm._v("Org ID: " + _vm._s(_vm.org['.key']))]), _vm._v(" "), _c('p', [_vm._v("Email Alerts: " + _vm._s(_vm.org.emails ? 'Enabled' : 'Disabled'))]), _vm._v(" "), _c('p', [_vm._v("Chat: " + _vm._s(_vm.org.chat ? 'Enabled' : 'Disabled'))]), _vm._v(" "), _c('p', [_vm._v("Inventory: " + _vm._s(_vm.org.inventory ? 'Enabled' : 'Disabled'))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default form-group",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info form-group",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#showQRCodeModal"
    }
  }, [_vm._v("ShowQRCode")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "OrganizationEditing col-md-5"
  }, [_c('form-text', {
    ref: "orgname",
    attrs: {
      "styler": "font-size:35px",
      "label": "Organization Name",
      "name": "organizationname",
      "validation": "required"
    },
    model: {
      value: (_vm.orgEdit.name),
      callback: function($$v) {
        _vm.$set(_vm.orgEdit, "name", $$v)
      },
      expression: "orgEdit.name"
    }
  }), _vm._v(" "), _c('form-textarea', {
    ref: "orgdescription",
    attrs: {
      "abel": "Description",
      "name": "description"
    },
    model: {
      value: (_vm.orgEdit.description),
      callback: function($$v) {
        _vm.$set(_vm.orgEdit, "description", $$v)
      },
      expression: "orgEdit.description"
    }
  }), _vm._v(" "), _c('form-checkbox', {
    attrs: {
      "label": "Email Alerts",
      "name": "emails"
    },
    model: {
      value: (_vm.orgEdit.emails),
      callback: function($$v) {
        _vm.$set(_vm.orgEdit, "emails", $$v)
      },
      expression: "orgEdit.emails"
    }
  }), _vm._v(" "), _c('form-checkbox', {
    attrs: {
      "label": "Chat",
      "name": "chat"
    },
    model: {
      value: (_vm.orgEdit.chat),
      callback: function($$v) {
        _vm.$set(_vm.orgEdit, "chat", $$v)
      },
      expression: "orgEdit.chat"
    }
  }), _vm._v(" "), _c('form-checkbox', {
    attrs: {
      "label": "Inventory",
      "name": "inventory"
    },
    model: {
      value: (_vm.orgEdit.inventory),
      callback: function($$v) {
        _vm.$set(_vm.orgEdit, "inventory", $$v)
      },
      expression: "orgEdit.inventory"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn  btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn  btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_vm._v("Submit")])])], 1)])])])]), _vm._v(" "), _c('showqrcode', {
    attrs: {
      "name": "showQRCodeModal",
      "orgid": _vm.org['.key']
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71692c23","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stanadmin/Organizations/OrganizationDetail.vue
// module id = 645
// module chunks = 1